import '../scss/foundation.scss';
import '../scss/main.scss';

// Either import everything
//import 'foundation-sites;


// Or import individual modules
/**/
import 'foundation-sites/dist/js/plugins/foundation.core';
import 'foundation-sites/dist/js/plugins/foundation.dropdownMenu.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.keyboard.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.box.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.nest.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.mediaQuery';
import 'foundation-sites/dist/js/plugins/foundation.util.imageLoader';
import 'foundation-sites/dist/js/plugins/foundation.util.motion';
import 'foundation-sites/dist/js/plugins/foundation.util.triggers';
import 'foundation-sites/dist/js/plugins/foundation.util.touch';
import 'foundation-sites/dist/js/plugins/foundation.equalizer';
import 'foundation-sites/dist/js/plugins/foundation.reveal';
import 'foundation-sites/dist/js/plugins/foundation.tabs';

import Accordions from './modules/Accordions';
import Glide from '@glidejs/glide';

document.addEventListener("DOMContentLoaded", function () {
	$(document).foundation();

	// video modal open
	$('.modal-link').on('click', function () {
		$('#video-modal').foundation('open');
		$('.embed-player').attr("src", $(this).attr('data-video-link'));
		$('.embed-player').attr("title", $(this).attr('data-video-title'));
		$('.video-transcript .btn').attr("href", $(this).attr('data-video-transcript'));
	});

	// reveal video close and stop
	$('.reveal-overlay').on('click', function (e) {
		$('.reveal-video iframe').attr('src', '');
	});
	$('.reveal-video .close-button').on('click', function (e) {
		$('.reveal-video iframe').attr('src', '');
	});
	$('.reveal-video .video-transcript .btn-primary').on('click', function (e) {
		var tempLink = $('.reveal-video iframe').attr('src');
		var tempTitle = $('.reveal-video iframe').attr('title');
		$('.reveal-video iframe').attr('src', '');
		setTimeout(function(){ 
			$('.reveal-video iframe').attr('src', tempLink);
			$('.reveal-video iframe').attr('title', tempTitle);
		}, 500);
	});
	$(document).on('keyup', function (evt) {
		if (evt.keyCode == 27) {
			$('.reveal-video iframe').attr('src', '');
		}
	});

	// tabs
	$('.tabs-title a').on('click', function() {		
		var tabId = $(this).attr('data-tabs-target');
		$('.tab-accordion-title').removeClass('is-active');
		$(`.tab-accordion-title[data-tab-id='${tabId}']`).addClass('is-active');
		$(`#${tabId}`).siblings().removeClass('is-active');
		$(`#${tabId}`).addClass('is-active');
	});
	// tabs mobile
	$('.tab-accordion-title').on('click', function() {
		var currId = $(this).attr('data-tab-id'),
				tabs = $('.tabs');
		tabs.find('.tabs-title').removeClass('is-active');
		$('.tabs-panel').removeClass('is-active');
		$('.tab-accordion-title').removeClass('is-active');
		$(this).parent('.tabs-panel').addClass('is-active');
		$(this).addClass('is-active');
		tabs.find('.tabs-title').removeClass('is-active');
		tabs.find('.tabs-title').find(`[data-tabs-target='${currId}']`).parent('.tabs-title').addClass('is-active');
	});	

	// glide slider
	const COMPONENT_NAME = "data-glide";
	const COMPONENT_SELECTOR = `[${COMPONENT_NAME}]`;

	const components = document.querySelectorAll(COMPONENT_SELECTOR);

	for (let i = 0; i < components.length; i++) {
		const options = JSON.parse(
			components[i].getAttribute(COMPONENT_NAME) || "{}"
		);

		let glide = new Glide(
			components[i],
			options
		);

    components[i].addEventListener('keyup', (e) => {
			if (e.keyCode == 39){
				glide.go('>');
			} 
			if (e.keyCode == 37){
				glide.go('<');
			} 
		});		

		glide.mount();
	}	

	function setEqualHeight() {
		// Reset the height to auto before recalculating
		$('.item-person-bottom h3').height('auto');

		var maxHeight = 0;

		// Iterate through each item-person-bottom element
		$('.item-person-bottom').each(function() {
			// Find the height of the h3 element in the current item-person-bottom
			var h3Height = $(this).find('h3').outerHeight();

			// Update the maxHeight if the current h3Height is greater
			maxHeight = Math.max(maxHeight, h3Height);
		});

		// Set the height of all h3 elements to the maxHeight
		$('.item-person-bottom h3').height(maxHeight);
	}

	// Call the function on page load
	setEqualHeight();

	// Call the function whenever the window is resized
	$(window).resize(function() {
		console.log('resize');
		setEqualHeight();
	});	

	// accordions
	const accordion = new Accordions();
	accordion.init();


});
